import { find } from 'lodash'
import request, { ResponseData } from './request'
import { getContentType } from 'common/util'
import { shoppingService } from './apiPrefix'

export const getLikeStatus = async (id: number) => {
  const contentType = await getContentType()
  return request<ResponseData<ILikeInfo[]>>(`${await shoppingService()}/likes/get_likes`, {
    method: 'POST',
    data: {
      doc_ids: [id],
      doc_type: contentType.doctype,
    },
  })
    .then(data => find(data.data, o => o.doc_id === id))
    .then(data => (data ? data : Promise.reject(undefined)))
}

export const likeTutorialDetail = async (detail_id: number) => {
  const contentType = await getContentType()
  return request(`${await shoppingService()}/likes/like`, {
    method: 'POST',
    data: {
      doc_id: detail_id,
      doc_type: contentType.doctype,
    },
  })
}

export const unlikeTutorialDetail = async (detail_id: number) => {
  const contentType = await getContentType()
  return request(`${await shoppingService()}/likes/dis_like`, {
    method: 'POST',
    data: {
      doc_id: detail_id,
      doc_type: contentType.doctype,
    },
  })
}
